/**
*
* NewFeaturesDialog
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import BulletList from 'ui/BulletList';
import homePageMessages from 'pages/HomePage/messages';
import splashbackMessages from 'domain/Options/generators/messages/splashbackMessages';
import parameterMessages from 'domain/Options/parameterMessages';
import shapeMessages from 'domain/Options/generators/messages/shapeMessages';
import messages from './messages';
import { KompisPrompt, KompisText } from '@inter-ikea-kompis/react-components';
import { PromptButtonTypeEnum } from '@inter-ikea-kompis/component-prompt';
import { SkapaTheme } from '@inter-ikea-kompis/themes';

const StyledBulletList = styled(BulletList)`
  margin: 8px 0 8px 16px;
`;

export default function NewFeaturesDialog({ show, onDismiss, onDismissNewFeaturesSeen, cwcalcReachedFromIpexGallery }) {
  const { formatMessage } = useIntl();
  const bulletList = [
    { key: '1', text: messages.comparePlans },
    { key: '2', text: [splashbackMessages.wallPanel, ' + ', messages.cutOuts] },
    { key: '3', text: splashbackMessages.wallEdgingStrip },
    { key: '4', text: [parameterMessages.kitchenIsland, ' (', shapeMessages.rectangular, ')'] },
    { key: '5', text: homePageMessages.print },
  ];

  return (
    <KompisPrompt
      heading={formatMessage({
        id: messages.newFeaturesTitle.id, defaultMessage: messages.newFeaturesTitle.defaultMessage
      })}
      primaryButtonLabel={formatMessage({
        id: messages.priceDifferenceOkButton.id, defaultMessage: messages.priceDifferenceOkButton.defaultMessage
      })}
      onButtonClick={event => {
        onDismiss();
        if (event.detail.type === PromptButtonTypeEnum.primaryButton) {
          // onContinueClick();
        } else {
          // onBackClick();
        }
      }}
      visible={show}
      theme={SkapaTheme}
      disableIframeSticky={cwcalcReachedFromIpexGallery}
    >
      <KompisText theme={SkapaTheme}>
        {formatMessage({
          id: messages.newFeaturesSubtitle.id, defaultMessage: messages.newFeaturesSubtitle.defaultMessage
        })}
      </KompisText>
    <StyledBulletList list={bulletList} />
    </KompisPrompt>)
}

NewFeaturesDialog.propTypes = {
  show: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onDismissNewFeaturesSeen: PropTypes.func.isRequired,
};
